import {
  ADMIN_CONFIGURATIONS_PATH,
  ADMIN_DIST_ORG,
  ALIAS_PATH,
  AUDIT_EVENTS_PATH,
  ANALYTICS_CATEGORY_DISTRIBUTION_BY_DISTRIBUTOR_PATH,
  ANALYTICS_DEMO_TEST_TOTALS_PATH,
  ANALYTICS_DISTRIBUTOR_COMPARISON_PATH,
  ANALYTICS_MULTI_ACCOUNT_DEVICES_PATH,
  ANALYTICS_DISTRIBUTOR_SALES_PATH,
  ANALYTICS_EXPORT_PATH,
  ANALYTICS_ORG_BREAKDOWN_PATH,
  ANALYTICS_TEST_COUNT_BY_DEVICE_PATH,
  ANALYTICS_TEST_COUNT_BY_DISTRIBUTOR_PATH,
  ANALYTICS_TEST_COUNT_PATH,
  DISTRIBUTOR_IDS_WITH_COUNTRY_PATH,
  ASSIGN_SCOPE_PATH,
  BASELINE_PATH,
  BLOG_PATH,
  CAREERS_APPLY_JOB_PATH,
  CHANGE_PASS_PATH,
  CHATBASE_IDENTITY_PATH,
  CONTACT_FORM_PATH,
  CPT_EXCEL_EXPORT_JOB_PATH,
  DEFAULT_CONFIG_DEVICES_BY_VERSION_PATH,
  DEFAULT_CONFIG_DEVICES_PATH,
  DEFAULT_CONFIG_PATH,
  DEVICE_LOG_PATH,
  DICOM_CREATE_PATH,
  DISTRIBUTOR_PATH,
  DIST_ALIAS_PATH,
  DIST_APPROVE_ORG_REQ,
  DIST_CREATE_ORG_REQ,
  DIST_DELETE_ORG_REQ,
  DIST_GET_ORGS,
  ORG_LIST_PATH,
  DIST_GET_REQS,
  DIST_GET_USERS,
  FORGOT_PASS_PATH,
  GET_ORGS_WITH_SCOPE_PATH,
  HELP_FORM_PATH,
  HELP_REQUESTS_PATH,
  ID_PATH,
  LOG_PATH,
  MANAGEMENT_ASSIGN_REQUESTS_PATH,
  MANAGEMENT_IMPORT_INVOICES_CSV_PATH,
  MANAGEMENT_IMPORT_INVOICES_JSON_PATH,
  MANAGEMENT_INVOICES_PATH,
  MANAGEMENT_INVOICE_SKU_TYPES_PATH,
  MANAGEMENT_LICENCES_PATH,
  MANAGEMENT_ORDERS_PATH,
  MANAGEMENT_PARENT_OFFERS_PATH,
  MFA_ENABLE_PATH,
  MFA_ENABLE_VERIFY_PATH,
  MFA_PATH,
  NOTIFICATIONS_ADMIN_PATH,
  NOTIFICATIONS_ELIGIBLE_PATH,
  NOTIFICATIONS_PATH,
  ORG_APPROVE_OFFLINE_REQUEST_PATH,
  ORG_REISSUE_OFFLINE_LICENSE_PATH,
  ORG_APPROVE_OR_DENY_SUBMISSION_PATH,
  ORG_CANCEL_SUBMISSION_PATH,
  ORG_CHECK_USERNAME_PATH,
  ORG_CREATE_ADD_DEVICE_SUBMISSION_PATH,
  ORG_CREATE_OFFLINE_REQUEST_PATH,
  ORG_CREATE_REMOVE_DEVICE_SUBMISSION_PATH,
  ORG_DELETE_OFFLINE_REQUEST_PATH,
  ORG_DIST_UPDATE_PATH,
  ORG_GET_CREATED_SUBMISSIONS_PATH,
  ORG_GET_OFFLINE_REQUESTS_PATH,
  ORG_GET_ORG_FROM_PRODUCT_PATH,
  ORG_ONBOARDING_ADD_DEVICE_PATH,
  ORG_GET_PRODUCTS,
  ORG_GET_PRODUCTS_DETAILS,
  ORG_GET_PRODUCTS_VERSIONS,
  ORG_PATH,
  ORG_PID,
  ORG_SCOPE_DISTRIBUTION_PATH,
  ORG_TOGGLE_ACTIVE_PATH,
  ORG_UPLOAD_LOGO_PATH,
  ORG_USERS_LICENSE_INFO_PATH,
  ORG_USERS_PATH,
  ORG_VERSION_DISTRIBUTION_PATH,
  PATIENT_BULK_INSERT_PATH,
  PATIENT_PAGINATED_PATH,
  PATIENT_PATH,
  PRODUCT_CONFIG_PATH,
  PRODUCT_PAGINATED_PATH,
  PRODUCT_PATH,
  RAW_EXPORT_JOB_PATH,
  REFRESH_TOKEN_PATH,
  RESET_DEVICE_CONFIG_PATH,
  RESET_PASS_PATH,
  SCOPE_PATH,
  SIGN_IN_PATH,
  SYNC_CHECK_PATH,
  SYNC_PATH,
  SYNC_STATUS_PATH,
  SYSTEM_LOG_PATH,
  TEST_EXISTS_PATH,
  TEST_LIST_PATH,
  TEST_PATH,
  TEST_SUITE_PATH,
  TEST_SUITE_SESSION_PATH,
  TRANSLATIONS_PAGINATED_PATH,
  TRANSLATIONS_PATH,
  TURN_OFF_DEVICE_PATH,
  UPDATE_DEVICE_CONFIG_PATH,
  UPDATE_PLAYERPREF_PATH,
  USER_PATH,
  USER_RESET_PASSWORD_PATH,
  VERIFY_LOGIN,
  VIRTUAL_ASSISTANT_VIDEO_BLOB_PATH,
  VIRTUAL_ASSISTANT_VIDEO_ISSUE_REPORT_PATH,
  VIRTUAL_ASSISTANT_VIDEO_STREAM_PATH,
  WS_GET_CONFIG_PATH,
  WS_PATH,
} from "./ApiConstants";
import { convertToQueryString, isLoggedIn } from "../CommonUtil";
import { handleAuthFailure } from "../auth/authFailure";
import { v4 as uuidv4 } from "uuid";
import { getAxiosInstance, getDicomAxiosInstance } from "../axios-config/axios_config";

import { AssignLicensesToOrganizationsDto } from "../../types/licenseAssignmentTypes";
import { CreateDeviceSubmissionRequest, OnboardingAddDeviceRequest } from "@constants/apiConstants";
import { Patient } from "../../model/Patient";
import { AdminConfigurations, AdminConfigurationsResponse } from "@/types/adminConfigurationTypes";
import {
  AdminNotification,
  EligibleNotification,
  NotificationEventRequest,
  NotificationPayload,
  NotificationTargetPayload,
} from "@/types/notificationTypes";
import type {
  AdminSchoolOffer,
  AdminSchoolOffersResponse,
  ParentOfferCurrencyCheck,
  ParentOfferInput,
  ParentOfferLogoUpload,
  ParentOfferOrgSearchResponse,
  RegistrationsQuery,
  RegistrationsResponse,
} from "@/types/parentPortalAdminTypes";
import { Scope } from "../../types/managementTypes";
import { SecureTokenManager } from "../auth/secureTokenManager";
import { SubmissionUpdate } from "types/userTypes";
import { TestSession } from "../../model/TestSession";
import { TestSuiteOverview } from "../OverviewUtils";
import { ClinicianReviewPayload, TestType } from "types/tests";
import { VAVideoFetchError } from "types/vaVideoTypes";
import axios from "axios";
import extractIDInfo from "./extractIDInfo";
import { getOrganizationId } from "../AuthUtil";
import type { HelpRequestSource, SupportDeviceContext } from "@utils/supportContext";

export function sendEmail(data: any, callback?: (val: any) => void, errorCallback?: (val) => void) {
  postMethod(CONTACT_FORM_PATH, {}, data, callback, errorCallback);
}

export function sendHelpRequest(
  message: string,
  replyToEmail?: string,
  callback?: (val: any) => void,
  errorCallback?: (val) => void,
  deviceContext?: SupportDeviceContext,
  source?: HelpRequestSource,
) {
  postMethod(
    HELP_FORM_PATH,
    {},
    {
      message,
      ...(replyToEmail !== undefined ? { replyToEmail: replyToEmail.trim() } : {}),
      ...(deviceContext ? { deviceContext } : {}),
      ...(source ? { source } : {}),
    },
    callback,
    errorCallback,
  );
}

export function getHelpRequests(
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  getMethod(HELP_REQUESTS_PATH, {}, callback, errorCallback, unAuth);
}

export function getHelpRequestMessages(
  ticketId: string,
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  getMethod(
    `${HELP_REQUESTS_PATH}/${encodeURIComponent(ticketId)}/messages`,
    {},
    callback,
    errorCallback,
    unAuth,
  );
}

export function sendHelpRequestReply(
  ticketId: string,
  message: string,
  callback?: (val: any) => void,
  errorCallback?: (val) => void,
) {
  postMethod(
    `${HELP_REQUESTS_PATH}/${encodeURIComponent(ticketId)}/replies`,
    {},
    { message },
    callback,
    errorCallback,
  );
}

function getHeaders(extra?) {
  let headers = {
    Authorization: "Bearer " + SecureTokenManager.getAccessToken(),
  };
  if (extra) {
    headers = { ...headers, ...extra };
  }
  return headers;
}

function logError(error) {
  console.log("logging error", error);
  try {
    handleAuthFailure(error);
  } catch (e) {
    console.error(e);
  }
}

export function getMethod(
  url: string,
  queryMap: {},
  callback?: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
  axiosInstance = getAxiosInstance(),
  signal?: AbortSignal,
) {
  isLoggedIn(unAuth);
  axiosInstance
    .get(url + convertToQueryString(queryMap), {
      headers: getHeaders(),
      signal,
    })
    .then(function (response) {
      if (typeof callback == "function") {
        callback(response);
      }
    })
    .catch(function (error) {
      if (axios.isCancel(error)) return;
      console.error(error);
      logError(error);
      if (typeof errorCallback == "function") {
        errorCallback(error);
      }
    });
}

async function getMethodAsyncNoAuth(url: string, queryMap: {}) {
  return await getAxiosInstance().get(url + convertToQueryString(queryMap), {
    headers: getHeaders(),
  });
}

export function getPatient(
  queryMap: {},
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  getMethod(PATIENT_PATH, queryMap, callback, errorCallback, unAuth);
}

export function getPatientsPaginated(
  queryMap: {},
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  getMethod(PATIENT_PAGINATED_PATH, queryMap, callback, errorCallback, unAuth);
}

export function getAuditEvents(
  queryMap: {},
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  getMethod(AUDIT_EVENTS_PATH, queryMap, callback, errorCallback, unAuth);
}

export function getOrganizationById(
  orgId,
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  getMethod(ORG_PATH, { orgId: orgId }, callback, errorCallback, unAuth);
}

export function patchOrganization(
  orgId,
  updateInfo,
  callback: () => void,
  errorCallback?: (val) => void,
  unAuth?: () => void,
) {
  postMethod(ORG_PATH, undefined, { orgId, ...updateInfo }, callback, errorCallback, unAuth);
}

export function uploadOrganizationLogoNoAuth(
  orgId: string,
  logo: File,
  callback: (val: any) => void,
  errorCallback?: (val) => void,
) {
  const formData = new FormData();
  formData.append("orgId", orgId);
  formData.append("logo", logo);

  // Use formData as the data parameter
  return postMethodAsyncNoAuth(ORG_UPLOAD_LOGO_PATH, {}, formData)
    .then((response) => {
      if (typeof callback === "function") {
        callback(response);
      }
      return response;
    })
    .catch((error) => {
      console.error(error);
      if (typeof errorCallback === "function") {
        errorCallback(error);
      }
      throw error;
    });
}

export function patchOrganizationDist(
  orgId,
  updateInfo,
  callback: (val: any) => void,
  errorCallback?: (val) => void,
  unAuth?: () => void,
) {
  postMethod(
    ORG_DIST_UPDATE_PATH,
    undefined,
    { orgId, ...updateInfo },
    callback,
    errorCallback,
    unAuth,
  );
}

export function toggleOrganizationActive(
  orgId: string,
  isActive: boolean,
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: () => void,
) {
  postMethod(
    ORG_TOGGLE_ACTIVE_PATH,
    undefined,
    { orgId, isActive },
    callback,
    errorCallback,
    unAuth,
  );
}

export function getProductIds(callback: (val) => void, errorCallback?: (val) => void) {
  getMethod(ORG_GET_PRODUCTS, {}, callback, errorCallback);
}

export function getProductsDetails(
  callback: (val) => void,
  errorCallback?: (val) => void,
  orgId = null,
  signal?: AbortSignal,
) {
  orgId = orgId != null ? orgId : getOrganizationId();
  getMethod(
    ORG_GET_PRODUCTS_DETAILS,
    { orgId },
    callback,
    errorCallback,
    undefined,
    undefined,
    signal,
  );
}

export async function getReadingLayout(query: { hash?: string; textId?: string; orgId?: string }) {
  if (!query?.hash && !query?.textId) {
    throw new Error("hash or textId is required");
  }

  return await new Promise((resolve, reject) => {
    getMethod(
      "/reading-layout",
      query,
      (response) => resolve(response.data),
      (error) => reject(error),
    );
  });
}

export async function getReadingLayoutCatalog(orgId?: string) {
  return await new Promise((resolve, reject) => {
    getMethod(
      "/reading-layout/catalog",
      orgId ? { orgId } : {},
      (response) => resolve(response.data),
      (error) => reject(error),
    );
  });
}

export async function upsertReadingLayout(body: {
  title?: string;
  textId: string;
  fullText: string;
  textOrientation?: "L2R" | "R2L";
  questions?: { question: string; correctAnswer: number; options: string[] }[];
  global?: boolean;
  orgId?: string;
  sourceHash?: string;
}) {
  return await new Promise((resolve, reject) => {
    postMethod(
      "/reading-layout",
      {},
      body,
      (response) => resolve(response.data),
      (error) => reject(error),
    );
  });
}

export async function deleteReadingLayout(hash: string) {
  return await new Promise((resolve, reject) => {
    deleteMethod(
      "/reading-layout",
      { hash },
      (response) => resolve(response.data),
      (error) => reject(error),
    );
  });
}

export function getProductsVersions(orgId) {
  return getMethodAsyncNoAuth(ORG_GET_PRODUCTS_VERSIONS, { orgId });
}

export function updateProductName(
  orgId,
  pid,
  name,
  callback: () => void,
  errorCallback?: () => void,
) {
  postMethod(PRODUCT_PATH, {}, { orgId, pid, name }, callback, errorCallback);
}

export function createOrgRequest(
  body,
  distId,
  callback: (val) => void,
  errorCallback?: (val) => void,
) {
  postMethod(DIST_CREATE_ORG_REQ, { distId }, body, callback, errorCallback);
}

export function checkUsernameAvailability(
  username: string,
  callback: (val) => void,
  errorCallback?: (val) => void,
  signal?: AbortSignal,
) {
  getMethod(
    ORG_CHECK_USERNAME_PATH,
    { username: encodeURIComponent(username) },
    callback,
    errorCallback,
    undefined,
    getAxiosInstance(),
    signal,
  );
}

export function createAddDeviceSubmission(
  body: CreateDeviceSubmissionRequest,
  callback: (val) => void,
  errorCallback?: (val) => void,
) {
  postMethod(ORG_CREATE_ADD_DEVICE_SUBMISSION_PATH, {}, body, callback, errorCallback);
}

export function createRemoveDeviceSubmission(
  body: CreateDeviceSubmissionRequest,
  callback: (val) => void,
  errorCallback?: (val) => void,
) {
  postMethod(ORG_CREATE_REMOVE_DEVICE_SUBMISSION_PATH, {}, body, callback, errorCallback);
}

export function addOnboardingDevice(
  body: OnboardingAddDeviceRequest,
  callback: (val) => void,
  errorCallback?: (val) => void,
) {
  postMethod(ORG_ONBOARDING_ADD_DEVICE_PATH, {}, body, callback, errorCallback);
}

export function getOrgIdsFromProductUuid(
  productUuid: string,
  callback: (val) => void,
  errorCallback?: (val) => void,
) {
  getMethod(ORG_GET_ORG_FROM_PRODUCT_PATH, { productUuid }, callback, errorCallback);
}

export function createOfflineLicenseRequest(
  body,
  callback: (val) => void,
  errorCallback?: (val) => void,
) {
  postMethod(ORG_CREATE_OFFLINE_REQUEST_PATH, {}, body, callback, errorCallback);
}

export function approveOrgRequest(body, callback: (val) => void, errorCallback?: (val) => void) {
  postMethod(DIST_APPROVE_ORG_REQ, {}, body, callback, errorCallback);
}

export function approveOfflineLicenseRequest(
  body,
  callback: (val) => void,
  errorCallback?: (val) => void,
) {
  postMethod(ORG_APPROVE_OFFLINE_REQUEST_PATH, {}, body, callback, errorCallback);
}

export function reissueOfflineLicense(
  body: { username: string; expiresAt?: string | null },
  callback: (val) => void,
  errorCallback?: (val) => void,
) {
  postMethod(ORG_REISSUE_OFFLINE_LICENSE_PATH, {}, body, callback, errorCallback);
}

export function changeAlias(isDist, body, callback: (val) => void, errorCallback?: (val) => void) {
  postMethod(isDist ? DIST_ALIAS_PATH : ALIAS_PATH, {}, body, callback, errorCallback);
}

export function deleteOrgRequest(body, callback: (val) => void, errorCallback?: (val) => void) {
  postMethod(DIST_DELETE_ORG_REQ, {}, body, callback, errorCallback);
}

export function deleteOfflineLicenseRequest(
  body,
  callback: (val) => void,
  errorCallback?: (val) => void,
) {
  postMethod(ORG_DELETE_OFFLINE_REQUEST_PATH, {}, body, callback, errorCallback);
}

export function setBaselineTests(body, callback: (val) => void, errorCallback?: (val) => void) {
  postMethod(BASELINE_PATH, {}, body, callback, errorCallback);
}

export function getBaselineTests(queryMap, callback: (val) => void, errorCallback?: (val) => void) {
  getMethod(BASELINE_PATH, queryMap, callback, errorCallback);
}

export function getProduct(pid, callback: (val) => void, errorCallback?: (val) => void) {
  getMethod(PRODUCT_PATH, { uuid: pid }, callback, errorCallback);
}

export function getProductsPaginatedAndFiltered(
  limit: number,
  page: number,
  filter: string | null,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  const queryMap = { limit, page, ...(filter ? { filter } : {}) };
  getMethod(PRODUCT_PAGINATED_PATH, queryMap, callback, errorCallback);
}

/**
 * Admin product version distribution. Returns one entry per device in scope
 * (whole fleet, a single org, or a distributor's orgs) with its version and
 * owning org. The backend does the fleet read and org join.
 */
export function getVersionDistribution(
  params: { orgId?: string; distId?: string },
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  getMethod(ORG_VERSION_DISTRIBUTION_PATH, params, callback, errorCallback);
}

/**
 * Admin scope distribution. Returns { orgCounts, productCounts } for the scope
 * (whole fleet, a single org, or a distributor's orgs), computed server-side
 * with authoritative org/product scopeName.
 */
export function getScopeDistribution(
  params: { orgId?: string; distId?: string },
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  getMethod(ORG_SCOPE_DISTRIBUTION_PATH, params, callback, errorCallback);
}

export function getOrganizationsOfProductIds(
  pid: string,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  const queryMap = { pid };
  getMethod(ORG_PID, queryMap, callback, errorCallback);
}

export function postLog(message: any, code: any) {
  return postMethodAsyncNoAuth(LOG_PATH, {}, { message, code });
}

export function getDeviceLogs(
  pid,
  page,
  limit,
  callback: (val) => void,
  errorCallback?: (val) => void,
  code?: string,
) {
  return getMethod(
    DEVICE_LOG_PATH,
    { pid, page, limit, ...(code ? { code } : {}) },
    callback,
    errorCallback,
  );
}

export interface SystemLogQuery {
  page: number;
  limit: number;
  code?: string;
  pid?: string;
  username?: string;
  orgId?: string;
  auto?: boolean;
  from?: string;
  to?: string;
}

export function getSystemLogs(
  query: SystemLogQuery,
  callback: (val) => void,
  errorCallback?: (val) => void,
) {
  const params: Record<string, string | number> = {
    page: query.page,
    limit: query.limit,
  };
  if (query.code) params.code = query.code;
  if (query.pid) params.pid = query.pid;
  if (query.username) params.username = query.username;
  if (query.orgId) params.orgId = query.orgId;
  if (query.auto !== undefined) params.auto = String(query.auto);
  if (query.from) params.from = query.from;
  if (query.to) params.to = query.to;
  return getMethod(SYSTEM_LOG_PATH, params, callback, errorCallback);
}

export function getLogs(pid, page, limit, callback: (val) => void, errorCallback?: (val) => void) {
  return getMethod(LOG_PATH, { pid, page, limit }, callback, errorCallback);
}

export function getTestList(
  queryMap: {},
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  getMethod(TEST_PATH, queryMap, callback, errorCallback, unAuth);
}

export function getTestListLean(
  queryMap: {},
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  getMethod(TEST_LIST_PATH, queryMap, callback, errorCallback, unAuth);
}

// Lightweight existence probe: the full /test payload can be ~100 MB, so the
// recovery completion poll must not pull it just to test for presence. The
// backend returns { exists: boolean } for the given uuid.
export function checkTestExists(
  queryMap: { uuid: string },
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  getMethod(TEST_EXISTS_PATH, queryMap, callback, errorCallback, unAuth);
}

export function deleteTest(
  queryMap: {},
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  deleteMethod(TEST_PATH, queryMap, callback, errorCallback, unAuth);
}

export function changeTestPatient(
  testUuid: string,
  patientUuid: string,
  callback?: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  patchMethod(`${TEST_PATH}/${testUuid}/patient`, {}, { patientUuid }, callback, errorCallback);
}

export function updateTestClinicianReview(
  testUuid: string,
  body: ClinicianReviewPayload,
  callback?: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  patchMethod(`${TEST_PATH}/${testUuid}/labels`, {}, body, callback, errorCallback);
}

export function deletePatient(
  uuid: string,
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  deleteMethod(PATIENT_PATH + "/" + uuid, {}, callback, errorCallback, unAuth);
}

export function initiateSync(
  queryMap: {},
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  getMethod(SYNC_PATH, queryMap, callback, errorCallback, unAuth);
}

export function checkSyncEnabled(
  queryMap: {},
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  getMethod(SYNC_CHECK_PATH, queryMap, callback, errorCallback, unAuth);
}

export function getSyncStatus(
  queryMap: {},
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  getMethod(SYNC_STATUS_PATH, queryMap, callback, errorCallback, unAuth);
}

export function getOperators(
  queryMap: {},
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  getMethod(USER_PATH, queryMap, callback, errorCallback, unAuth);
}

export function getOrgsOfDistributor(
  queryMap: {},
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  getMethod(DIST_GET_ORGS, queryMap, callback, errorCallback, unAuth);
}

export function getOrganizationsPaginated(
  queryMap: Record<string, string | number | boolean>,
  callback: (val) => void,
  errorCallback?: (val) => void,
  signal?: AbortSignal,
) {
  getMethod(
    ORG_LIST_PATH,
    queryMap,
    callback,
    errorCallback,
    undefined,
    getAxiosInstance(),
    signal,
  );
}

export function getUsersOfOrg(
  queryMap: {},
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  getMethod(DIST_GET_USERS, queryMap, callback, errorCallback, unAuth);
}

export function getUsersLicenseInfo(
  orgId: string,
  callback: (val) => void,
  errorCallback?: (val) => void,
) {
  getMethod(ORG_USERS_LICENSE_INFO_PATH, { orgId }, callback, errorCallback);
}

export function getDistributorOrgs(
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  getMethod(ADMIN_DIST_ORG, {}, callback, errorCallback, unAuth);
}

export function getOrgsRequests(
  queryMap: {},
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  getMethod(DIST_GET_REQS, queryMap, callback, errorCallback, unAuth);
}

export function getOfflineLicenseRequests(
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  getMethod(ORG_GET_OFFLINE_REQUESTS_PATH, {}, callback, errorCallback, unAuth);
}

export function getSubmissions(
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  getMethod(ORG_GET_CREATED_SUBMISSIONS_PATH, {}, callback, errorCallback, unAuth);
}

export function updateOrDenySubmissionRequest(
  submissionUpdate: SubmissionUpdate,
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  postMethod(
    ORG_APPROVE_OR_DENY_SUBMISSION_PATH,
    {},
    submissionUpdate,
    callback,
    errorCallback,
    unAuth,
  );
}

export function cancelSubmission(
  submissionId: string,
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  deleteMethod(ORG_CANCEL_SUBMISSION_PATH, { submissionId }, callback, errorCallback, unAuth);
}

export function createDicomFile(
  body,
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  postMethod(
    DICOM_CREATE_PATH,
    {},
    body,
    callback,
    errorCallback,
    unAuth,
    getDicomAxiosInstance(),
    { responseType: "blob" },
  );
}

export function createDicomPerimetry(
  testId: string,
  kind: "opv" | "encapsulated-pdf",
  body: object,
): Promise<ArrayBuffer> {
  return new Promise((resolve, reject) => {
    postMethod(
      `/dicom/perimetry-test/${encodeURIComponent(testId)}/${kind}`,
      {},
      body,
      (response) => resolve(response.data),
      (err) => reject(err instanceof Error ? err : new Error(String(err))),
      undefined,
      getAxiosInstance(),
      { responseType: "arraybuffer" },
    );
  });
}

export interface PacsMwlEndpoint {
  enabled: boolean;
  host: string;
  aet: string;
  port: number;
}

export interface PacsStoreEndpoint {
  enabled: boolean;
  autoSend: boolean;
  deviceAet: string;
  host: string;
  aet: string;
  port: number;
}

export interface PacsMppsEndpoint {
  enabled: boolean;
  useMwlServer: boolean;
  host: string;
  aet: string;
  port: number;
}

export interface PacsConfigData {
  mwl: PacsMwlEndpoint;
  store: PacsStoreEndpoint;
  mpps: PacsMppsEndpoint;
}

export interface PacsEchoResult {
  success: boolean;
  status: number;
  message: string;
}

export interface WorklistItem {
  patientId?: string;
  patientName?: string;
  patientBirthDate?: string;
  patientSex?: string;
  accessionNumber?: string;
  studyInstanceUid?: string;
  modality?: string;
  scheduledDate?: string;
  scheduledTime?: string;
  scheduledStepId?: string;
}

export interface PacsSendResult {
  sopInstanceUid: string;
  success: boolean;
}

export interface MppsStartResult {
  sopInstanceUid: string;
  success: boolean;
}

export function getPacsConfig(): Promise<PacsConfigData> {
  return new Promise((resolve, reject) => {
    getMethod(
      "/dicom/pacs/config",
      {},
      (response) => resolve(response.data),
      (err) => reject(err instanceof Error ? err : new Error(String(err))),
    );
  });
}

export function upsertPacsConfig(body: PacsConfigData): Promise<PacsConfigData> {
  return new Promise((resolve, reject) => {
    putMethod(
      "/dicom/pacs/config",
      {},
      body,
      (_uuid, response) => resolve(response.data),
      (err) => reject(err instanceof Error ? err : new Error(String(err))),
    );
  });
}

export function testPacsConnection(target: "store" | "mwl" | "mpps"): Promise<PacsEchoResult> {
  return new Promise((resolve, reject) => {
    postMethod(
      "/dicom/pacs/test-connection",
      { target },
      {},
      (response) => resolve(response.data),
      (err) => reject(err instanceof Error ? err : new Error(String(err))),
    );
  });
}

export function startMpps(
  testId: string,
  body: {
    uids: { studyInstanceUid: string; uidRoot: string };
    accessionNumber?: string;
    scheduledStepId?: string;
  },
): Promise<MppsStartResult> {
  return new Promise((resolve, reject) => {
    postMethod(
      `/dicom/pacs/mpps/perimetry-test/${encodeURIComponent(testId)}/start`,
      {},
      body,
      (response) => resolve(response.data),
      (err) => reject(err instanceof Error ? err : new Error(String(err))),
    );
  });
}

export function completeMpps(
  mppsSopInstanceUid: string,
  body: {
    uids: { studyInstanceUid: string; uidRoot: string };
    status?: "COMPLETED" | "DISCONTINUED";
  },
): Promise<{ success: boolean }> {
  return new Promise((resolve, reject) => {
    postMethod(
      `/dicom/pacs/mpps/${encodeURIComponent(mppsSopInstanceUid)}/complete`,
      {},
      body,
      (response) => resolve(response.data),
      (err) => reject(err instanceof Error ? err : new Error(String(err))),
    );
  });
}

export function getPacsWorklist(): Promise<WorklistItem[]> {
  return new Promise((resolve, reject) => {
    getMethod(
      "/dicom/pacs/worklist",
      {},
      (response) => resolve(response.data?.items ?? []),
      (err) => reject(err instanceof Error ? err : new Error(String(err))),
    );
  });
}

export function sendTestToPacs(
  testId: string,
  body: { uids: { studyInstanceUid: string; uidRoot: string }; objectType?: "opv" | "pdf" },
): Promise<PacsSendResult> {
  return new Promise((resolve, reject) => {
    postMethod(
      `/dicom/pacs/perimetry-test/${encodeURIComponent(testId)}/send`,
      {},
      body,
      (response) => resolve(response.data),
      (err) => reject(err instanceof Error ? err : new Error(String(err))),
    );
  });
}

function putMethod(
  url: string,
  queryMap: {},
  data: {},
  callback?: (val, val2) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
  axiosInstance = getAxiosInstance(),
  headers = {},
) {
  isLoggedIn(unAuth);
  axiosInstance
    .put(url + convertToQueryString(queryMap), data, {
      headers: {
        ...headers,
        ...getHeaders(),
      },
    })
    .then(function (response) {
      if (typeof callback == "function") {
        callback(data ? data["uuid"] : null, response);
      }
    })
    .catch(function (error) {
      console.error(error);
      logError(error);
      if (typeof errorCallback == "function") {
        errorCallback(error);
      }
    });
}

export function createPatient(
  patient: Patient,
  callback: (val) => void,
  errorCallback: (val) => void,
  alreadyExistCallback: (val) => void,
  unAuth?: (val) => void,
) {
  patient.name = patient.name.toLowerCase();
  // Existence must be keyed on uuid alone, matching the backend's unique
  // { orgId, uuid }. Also matching name/dob misses a patient already stored
  // under that id with a different name/dob (e.g. a DICOM-scheduled patient),
  // so the create then fails the id uniqueness with a 409.
  getPatient(
    { uuid: patient.uuid },
    (response) => {
      if (response.data.length < 1) {
        postMethod(PATIENT_PATH, "", patient.toDict(), callback, errorCallback);
      } else {
        alreadyExistCallback(response.data);
      }
    },
    unAuth,
  );
}

export function bulkInsertPatients(
  patients: Array<{ uuid?: string; name?: string; dob?: string }>,
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  postMethod(PATIENT_BULK_INSERT_PATH, "", patients, callback, errorCallback, unAuth);
}

export function updatePatient(
  prevPatientId: string,
  patient: Patient,
  callback: (val) => void,
  errorCallback: (val) => void,
  alreadyExistCallback: (val) => void,
  unAuth?: (val) => void,
  edit?: boolean,
) {
  patient.name = patient.name.toLowerCase();
  if (edit) patient.edit = true;

  postMethod(PATIENT_PATH + "/update", "", { ...patient, prevPatientId }, callback, errorCallback);
}

export function createTest(
  data: TestSession,
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  data.orgId = getOrganizationId();
  const testSession = data.toDict();

  putMethod(TEST_PATH, "", testSession, callback, errorCallback, unAuth);
}

export async function recognizeID(
  img,
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  const fileBase64 = await toBase64(img);

  putMethod(
    ID_PATH,
    "",
    fileBase64,
    (a, response) => callback(extractIDInfo(response.data)),
    errorCallback,
    unAuth,
    undefined,
    {
      "Content-Type": "text/plain",
      Accept: "*/*",
    },
  );
}

export async function turnOffDevice(body, callback: (val) => void, errorCallback?: (val) => void) {
  postMethod(TURN_OFF_DEVICE_PATH, {}, body, callback, errorCallback);
}

export async function updateDevicePlayerPref(
  body: { pid: string; key: string; value: string },
  callback: (val) => void,
  errorCallback?: (val) => void,
) {
  postMethod(UPDATE_PLAYERPREF_PATH, {}, body, callback, errorCallback);
}

async function postMethodAsyncNoAuth(url: string, queryMap: {}, data: {}, extraHeaders = {}) {
  return await getAxiosInstance().post(url + convertToQueryString(queryMap), data, {
    headers: getHeaders(extraHeaders),
  });
}

function deleteMethod(
  url: string,
  queryMap: {},
  callback?: (val: any) => void,
  errorCallback?: (val: any) => void,
  unAuth?: (val: any) => void,
) {
  isLoggedIn(unAuth);
  getAxiosInstance()
    .delete(url + convertToQueryString(queryMap), {
      headers: getHeaders(),
    })
    .then(function (response) {
      if (typeof callback == "function") {
        callback(response);
      }
    })
    .catch(function (error) {
      console.error(error);
      logError(error);
      if (typeof errorCallback == "function") {
        errorCallback(error);
      }
    });
}

export function postMethod(
  url: string,
  queryMap: {},
  data: {},
  callback?: (val: any) => void,
  errorCallback?: (val) => void,
  unAuth?: (val: any) => void,
  axiosInstance = getAxiosInstance(),
  responseHeaders = {},
) {
  isLoggedIn(unAuth);
  axiosInstance
    .post(url + convertToQueryString(queryMap), data, {
      headers: getHeaders(),
      ...responseHeaders,
    })
    .then(function (response) {
      if (typeof callback == "function") {
        callback(response);
      }
    })
    .catch(function (error) {
      console.error(error);
      logError(error);
      if (typeof errorCallback == "function") {
        errorCallback(error);
      }
    });
}

export function patchMethod(
  url: string,
  queryMap: {},
  data: {},
  callback?: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  isLoggedIn(unAuth);
  getAxiosInstance()
    .patch(url + convertToQueryString(queryMap), data, {
      headers: getHeaders(),
    })
    .then(function (response) {
      if (typeof callback == "function") {
        callback(response);
      }
    })
    .catch(function (error) {
      console.error(error);
      logError(error);
      if (typeof errorCallback == "function") {
        errorCallback(error);
      }
    });
}

export function applyJob(body) {
  return postMethodAsyncNoAuth(CAREERS_APPLY_JOB_PATH, {}, body, {
    "Content-Type": "multipart/form-data",
  });
}

export function updateOperator(
  data: {},
  callback: () => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  postMethod(USER_PATH, "", data, callback, errorCallback, unAuth);
}

export function triggerUpdate(
  data: {},
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  postMethod(WS_PATH + "/update-product", "", data, callback, errorCallback, unAuth);
}

export function getApkDownloadUrl(
  version: string,
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
  hardwareModel?: string,
) {
  // convertToQueryString does not URL-encode values, so encode here
  getMethod(
    WS_PATH + "/apk-download-url",
    {
      version: encodeURIComponent(version),
      ...(hardwareModel ? { hardwareModel: encodeURIComponent(hardwareModel) } : {}),
    },
    callback,
    errorCallback,
    unAuth,
  );
}

export function getConnectedWebsockets(
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  getMethod(WS_PATH + "/now", "", callback, errorCallback, unAuth);
}

export type DeviceSceneResult = {
  status: 200 | 304;
  scene: string | null;
  etag: string | null;
};

export async function getDeviceScene(
  pid: string,
  ifNoneMatch: string | null,
  signal?: AbortSignal,
): Promise<DeviceSceneResult> {
  isLoggedIn();
  try {
    const response = await getAxiosInstance().get(WS_PATH + "/scene", {
      params: { pid },
      headers: getHeaders(ifNoneMatch ? { "If-None-Match": ifNoneMatch } : undefined),
      signal,
      validateStatus: (status) => status === 200 || status === 304,
    });
    const etag = (response.headers?.etag ?? response.headers?.ETag ?? null) as string | null;
    if (response.status === 304) {
      return { status: 304, scene: null, etag };
    }
    return { status: 200, scene: response.data?.scene ?? null, etag };
  } catch (error) {
    if (axios.isCancel(error)) throw error;
    logError(error);
    throw error;
  }
}

export type DeviceRunState = {
  vrConnected: boolean;
  scene: string | null;
  activeTestRun: { uuid: string; status: string } | null;
};

// Read over REST rather than the relay: the relay can stop delivering headset
// messages to a page while the backend still tracks the run the headset reported.
export async function getDeviceRunState(pid: string): Promise<DeviceRunState | null> {
  try {
    isLoggedIn();
    const response = await getAxiosInstance().get(WS_PATH + "/readiness", {
      params: { pid },
      headers: getHeaders(),
    });
    const activeTestRun = response.data?.activeTestRun;
    return {
      vrConnected: response.data?.vrConnected === true,
      scene: typeof response.data?.scene === "string" ? response.data.scene : null,
      activeTestRun:
        typeof activeTestRun?.uuid === "string" && typeof activeTestRun?.status === "string"
          ? { uuid: activeTestRun.uuid, status: activeTestRun.status }
          : null,
    };
  } catch (error) {
    logError(error);
    return null;
  }
}

export function getScopes(callback: (val: any) => void, errorCallback?: (val: any) => void) {
  getMethod(SCOPE_PATH, {}, callback, errorCallback);
}

export function getScopeByName(
  scopeName: string,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  getMethod(SCOPE_PATH + "/" + encodeURIComponent(scopeName), {}, callback, errorCallback);
}

export function getDefaultConfigs(
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  getMethod(DEFAULT_CONFIG_PATH, {}, callback, errorCallback);
}

export function getDefaultConfigDevices(
  params: { hardwareModel: string; puiVersion: string; version: string },
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  getMethod(DEFAULT_CONFIG_DEVICES_PATH, params, callback, errorCallback);
}

/**
 * Devices grouped by (version, puiVersion) only — hardware model is ignored.
 * Returns { applied, notApplied, total } resolved on the backend.
 */
export function getDefaultConfigDevicesByVersion(
  params: { puiVersion: string; version: string },
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  getMethod(DEFAULT_CONFIG_DEVICES_BY_VERSION_PATH, params, callback, errorCallback);
}

export function getProductConfigsPaginatedAndFiltered(
  query: { limit: number; page: number; filter?: string; sortField?: string; sortOrder?: string },
  callback: (response: any) => void,
  errorCallback?: (error: any) => void,
) {
  getMethod(PRODUCT_CONFIG_PATH, query, callback, errorCallback);
}

export function assignScopeToMultipleOrgOrProduct(
  data: {
    scopeName: string;
    orgIds: string[];
    productUuids?: string[];
  },
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  postMethod(ASSIGN_SCOPE_PATH, {}, data, callback, errorCallback);
}

export function getOrgsWithScope(
  scopeName: string,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  getMethod(GET_ORGS_WITH_SCOPE_PATH, { scopeName }, callback, errorCallback);
}

export function createOrUpdateDefaultConfig(
  data: {
    hardwareModel: string;
    puiVersion: string;
    version: string;
    config: Record<string, unknown>;
  },
  callback: (response: any) => void,
  errorCallback?: (error: any) => void,
) {
  postMethod(DEFAULT_CONFIG_PATH, {}, data, callback, errorCallback);
}

export function updateDeviceConfig(
  body: { pid: string; type: string; config: Record<string, unknown> },
  callback: (response: any) => void,
  errorCallback?: (error: any) => void,
) {
  postMethod(UPDATE_DEVICE_CONFIG_PATH, {}, body, callback, errorCallback);
}

export function resetDeviceConfig(
  body: { pid: string },
  callback: (response: any) => void,
  errorCallback?: (error: any) => void,
) {
  postMethod(RESET_DEVICE_CONFIG_PATH, {}, body, callback, errorCallback);
}

export function getDeviceSavedConfig(
  pid: string,
  callback: (response: any) => void,
  errorCallback?: (error: any) => void,
) {
  getMethod(WS_GET_CONFIG_PATH, { pid }, callback, errorCallback);
}

export function addScopes(
  data: any,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  postMethod(SCOPE_PATH, {}, data, callback, errorCallback);
}

export function updateScopeByName(
  name: string,
  data: Partial<Scope>,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  putMethod(`${SCOPE_PATH}/${name}`, {}, data, callback, errorCallback);
}

export function getAllDistributors(
  queryMap: {} | ((val: any) => void),
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  if (typeof queryMap === "function") {
    const callbackFn = queryMap as (val: any) => void;
    getMethod(DISTRIBUTOR_PATH, {}, callbackFn, callback);
    return;
  }

  getMethod(DISTRIBUTOR_PATH, queryMap, callback, errorCallback);
}

export function getDistributor(
  distId: string,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  getMethod(DISTRIBUTOR_PATH + "/one", { distId }, callback, errorCallback);
}

export function createDistributor(
  data: any,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  postMethod(DISTRIBUTOR_PATH, {}, data, callback, errorCallback);
}

export function editDistributor(
  data: any,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  patchMethod(`${DISTRIBUTOR_PATH}/me`, {}, data, callback, errorCallback);
}

export function deleteDistributor(
  distId: string,
  deactivateDistAccounts: boolean,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  deleteMethod(DISTRIBUTOR_PATH, { distId, deactivateDistAccounts }, callback, errorCallback);
}

export function login(data: {}) {
  return postMethodAsyncNoAuth(SIGN_IN_PATH, "", data);
}

export function verifyLogin(data: {}) {
  return postMethodAsyncNoAuth(VERIFY_LOGIN, "", data);
}

export function verifyMfa(data: {}) {
  return postMethodAsyncNoAuth(MFA_PATH, "", data);
}

export function forgotPassword(data: {}) {
  return postMethodAsyncNoAuth(FORGOT_PASS_PATH, "", data);
}

export function resetPassword(data: {}) {
  return postMethodAsyncNoAuth(RESET_PASS_PATH, "", data);
}

export interface ResetUserPasswordRequest {
  username: string;
  orgId: string;
  email: string;
}

export function resetUserPassword(
  data: ResetUserPasswordRequest,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  return postMethod(USER_RESET_PASSWORD_PATH, "", data, callback, errorCallback);
}

export type OrgUserRole =
  | "user"
  | "operator"
  | "manager"
  | "distributor"
  | "admin"
  | "superadmin"
  | "installer";

export interface CreateOrgUserRequest {
  orgId: string;
  username: string;
  password: string;
  role: OrgUserRole;
  name?: string;
  email?: string;
}

export function createOrgUser(
  data: CreateOrgUserRequest,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  return postMethod(ORG_USERS_PATH, {}, data, callback, errorCallback);
}

export function deleteOrgUser(
  userId: string,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  return deleteMethod(
    `${ORG_USERS_PATH}/${encodeURIComponent(userId)}`,
    {},
    callback,
    errorCallback,
  );
}

export interface RenameOrgUserRequest {
  username: string;
  migrateOrganization?: boolean;
}

export interface RenameOrgUserResponse {
  id: string;
  username: string;
  previousUsername: string;
  orgId?: string;
  migration: { oldOrgId: string; newOrgId: string; updated: Record<string, number> } | null;
}

export function renameOrgUser(
  userId: string,
  data: RenameOrgUserRequest,
  callback: (val: { data: RenameOrgUserResponse }) => void,
  errorCallback?: (val: any) => void,
) {
  return patchMethod(
    `${ORG_USERS_PATH}/${encodeURIComponent(userId)}/username`,
    {},
    data,
    callback,
    errorCallback,
  );
}

export function enableMfa(callback, errorCallback, unAuth?) {
  return postMethod(MFA_ENABLE_PATH, "", {}, callback, errorCallback, unAuth);
}

export function verifyMfaEnable(data: {}, callback, errorCallback, unAuth?) {
  return postMethod(MFA_ENABLE_VERIFY_PATH, "", data, callback, errorCallback, unAuth);
}

export function changePassword(data: {}) {
  return getAxiosInstance().post(CHANGE_PASS_PATH, data, {
    headers: getHeaders(),
  });
}

export function refreshTokenIfNeeded(
  callback?: (val: any) => void,
  errorCallback?: (val: any) => void,
  unAuth?: (val: any) => void,
) {
  return new Promise((resolve, reject) => {
    postMethod(
      REFRESH_TOKEN_PATH,
      {},
      {},
      (response) => {
        if (callback) callback(response);
        resolve(response);
      },
      (error) => {
        if (errorCallback) errorCallback(error);
        reject(error);
      },
      unAuth,
    );
  });
}

interface FetchVirtualAssistantVideoOptions {
  signal?: AbortSignal;
}

interface VirtualAssistantVideoResponse {
  blob?: Blob;
  url?: string;
}

export interface TestExportResponse {
  downloadUrl?: string;
  blob?: Blob;
  filename: string;
}

export interface ExportRequestOptions {
  onStatusChange?: (message: string | null) => void;
}

export interface VirtualAssistantVideoIssueReportRequest {
  videoName: string;
  username: string;
  videoLanguage: string;
  message: string;
}

interface ExportJobResponse {
  jobId: string;
  status: "queued" | "processing" | "completed" | "empty" | "failed";
  message: string;
  filename: string | null;
  statusUrl: string;
  downloadUrl: string | null;
  expiresAt: string | null;
}

const DEFAULT_EXPORT_POLL_INTERVAL_MS = 2000;
const DEFAULT_EXPORT_MAX_POLL_ATTEMPTS = 300;
const DEFAULT_EXPORT_REQUEST_TIMEOUT_MS = 10000;
const DEFAULT_EXPORT_DOWNLOAD_TIMEOUT_MS = 120000;
const DEFAULT_PRINT_REQUEST_TIMEOUT_MS = 90000;

function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function toAbsoluteApiUrl(axiosInstance: any, url: string) {
  return new URL(url, axiosInstance?.defaults?.baseURL ?? window.location.origin).toString();
}

function isApiOriginUrl(axiosInstance: any, downloadUrl: string) {
  const baseUrl = axiosInstance?.defaults?.baseURL;
  if (!baseUrl) {
    return false;
  }

  try {
    return new URL(downloadUrl, baseUrl).origin === new URL(baseUrl).origin;
  } catch {
    return false;
  }
}

async function executeExportRequest(
  path: string,
  body?: Record<string, unknown>,
  options?: ExportRequestOptions,
): Promise<TestExportResponse | null> {
  await SecureTokenManager.refreshIfNeeded();

  const axiosInstance = getAxiosInstance();

  if (!axiosInstance) {
    throw new Error("Axios instance not initialized. Call createAxiosInstance first.");
  }

  options?.onStatusChange?.("Preparing export...");

  try {
    const response = await axiosInstance.post(path, body ?? {}, {
      timeout: DEFAULT_EXPORT_REQUEST_TIMEOUT_MS,
      headers: getHeaders({
        "Content-Type": "application/json",
      }),
    });

    const initialJob = response.data as ExportJobResponse;

    return waitForExportJob(axiosInstance, initialJob, options);
  } catch (error) {
    logError(error);
    throw error;
  }
}

async function waitForExportJob(
  axiosInstance: any,
  initialJob: ExportJobResponse,
  options?: ExportRequestOptions,
): Promise<TestExportResponse | null> {
  let job = initialJob;

  for (let attempt = 0; attempt < DEFAULT_EXPORT_MAX_POLL_ATTEMPTS; attempt += 1) {
    options?.onStatusChange?.(job.message ?? "Preparing export...");

    if (job.status === "completed") {
      if (!job.downloadUrl || !job.filename) {
        throw new Error("Export is marked complete but no download URL was returned.");
      }

      const absoluteDownloadUrl = toAbsoluteApiUrl(axiosInstance, job.downloadUrl);

      if (!isApiOriginUrl(axiosInstance, job.downloadUrl)) {
        return {
          filename: job.filename,
          downloadUrl: absoluteDownloadUrl,
        };
      }

      options?.onStatusChange?.("Downloading export...");

      const download = await axiosInstance.get(job.downloadUrl, {
        responseType: "blob",
        timeout: DEFAULT_EXPORT_DOWNLOAD_TIMEOUT_MS,
        headers: getHeaders(),
      });

      return {
        filename: job.filename,
        downloadUrl: absoluteDownloadUrl,
        blob: download.data as Blob,
      };
    }

    if (job.status === "empty") {
      return null;
    }

    if (job.status === "failed") {
      throw new Error(job.message ?? "Export failed.");
    }

    await delay(DEFAULT_EXPORT_POLL_INTERVAL_MS);

    const pollResponse = await axiosInstance.get(job.statusUrl, {
      timeout: DEFAULT_EXPORT_REQUEST_TIMEOUT_MS,
      headers: getHeaders(),
    });

    job = pollResponse.data as ExportJobResponse;
  }

  throw new Error("Export is taking longer than expected. Please check back in a few minutes.");
}

export interface GenerateTestPdfBody {
  filename?: string;
  landscape?: boolean;
  queryFlags?: Record<string, string>;
}

export async function generateTestPdfAsync(
  uuidParam: string,
  body: GenerateTestPdfBody,
  options?: ExportRequestOptions,
): Promise<ArrayBuffer> {
  return runPdfExportJob(`/pdf/test/${uuidParam}/jobs`, body, options);
}

export async function generateSessionPdfAsync(
  sessionId: string,
  body: GenerateTestPdfBody,
  options?: ExportRequestOptions,
): Promise<ArrayBuffer> {
  return runPdfExportJob(`/pdf/session/${encodeURIComponent(sessionId)}/jobs`, body, options);
}

async function runPdfExportJob(
  createUrl: string,
  body: GenerateTestPdfBody,
  options?: ExportRequestOptions,
): Promise<ArrayBuffer> {
  await SecureTokenManager.refreshIfNeeded();

  const axiosInstance = getAxiosInstance();
  if (!axiosInstance) {
    throw new Error("Axios instance not initialized. Call createAxiosInstance first.");
  }

  options?.onStatusChange?.("Preparing your PDF...");

  const createResponse = await axiosInstance.post(createUrl, body, {
    timeout: DEFAULT_PRINT_REQUEST_TIMEOUT_MS,
    headers: getHeaders({ "Content-Type": "application/json" }),
  });

  const job = await waitForExportJob(
    axiosInstance,
    createResponse.data as ExportJobResponse,
    options,
  );

  if (!job) {
    throw new Error("PDF generation produced no document.");
  }
  if (!job.blob) {
    throw new Error("PDF generation completed but no document content was returned.");
  }

  return job.blob.arrayBuffer();
}

export async function fetchVirtualAssistantVideo(
  videoPath: string,
  options?: FetchVirtualAssistantVideoOptions,
): Promise<VirtualAssistantVideoResponse> {
  if (!videoPath) {
    throw new Error("Video path is required to stream the virtual assistant video");
  }

  await SecureTokenManager.refreshIfNeeded();

  const axiosInstance = getAxiosInstance();

  if (!axiosInstance) {
    throw new Error("Axios instance not initialized. Call createAxiosInstance before streaming.");
  }

  try {
    const response = await axiosInstance.get(VIRTUAL_ASSISTANT_VIDEO_STREAM_PATH, {
      params: { videoPath },
      responseType: "blob",
      headers: getHeaders(),
      withCredentials: true,
      signal: options?.signal,
    });

    if (!response?.data) {
      throw new Error("Empty response received from virtual assistant video stream");
    }

    const contentType = response.headers?.["content-type"] || "";

    if (contentType.toLowerCase().includes("video")) {
      return { blob: response.data as Blob };
    }

    if (contentType.toLowerCase().includes("application/json")) {
      const jsonText = await (response.data as Blob).text();

      try {
        const data = JSON.parse(jsonText) as { url?: string };

        if (data?.url) {
          return { url: data.url };
        }

        throw new Error("JSON response missing URL field");
      } catch (parseError) {
        if (parseError instanceof SyntaxError) {
          throw new Error("Invalid JSON response received from virtual assistant video stream");
        }

        throw parseError;
      }
    }

    throw new Error("Unsupported virtual assistant video response format");
  } catch (error) {
    if (axios.isCancel(error)) throw error;
    console.error("Error fetching virtual assistant video:", error);
    throw error;
  }
}

/**
 * Fetches a VA video as a raw Blob by streaming it through the backend.
 * Unlike fetchVirtualAssistantVideo, this never returns a presigned URL —
 * the backend pipes the S3 bytes directly, so there are no browser CORS issues.
 * Use this when you need the binary data (e.g. pushing via ADB).
 */

export async function fetchVirtualAssistantVideoBlob(
  videoPath: string,
  options?: FetchVirtualAssistantVideoOptions,
): Promise<Blob> {
  if (!videoPath) {
    throw new Error("Video path is required");
  }

  await SecureTokenManager.refreshIfNeeded();

  const axiosInstance = getAxiosInstance();
  if (!axiosInstance) {
    throw new Error("Axios instance not initialized. Call createAxiosInstance before fetching.");
  }

  try {
    const response = await axiosInstance.get(VIRTUAL_ASSISTANT_VIDEO_BLOB_PATH, {
      params: { videoPath },
      responseType: "blob",
      headers: getHeaders(),
      withCredentials: true,
      signal: options?.signal,
    });

    if (!response?.data) {
      throw new Error("Empty response from video blob endpoint");
    }

    return response.data as Blob;
  } catch (error: any) {
    if (error instanceof VAVideoFetchError) throw error;
    if (options?.signal?.aborted) throw new DOMException("Aborted", "AbortError");

    const status = error?.response?.status;
    if (status === 404) {
      throw new VAVideoFetchError("not_found", `Video not found on server: ${videoPath}`);
    }

    const msg = status
      ? `Server error (HTTP ${status}): ${videoPath}`
      : `Network error: ${videoPath}`;
    throw new VAVideoFetchError("network_error", msg);
  }
}

export async function exportCPTExcel(
  options?: ExportRequestOptions,
): Promise<TestExportResponse | null> {
  return executeExportRequest(CPT_EXCEL_EXPORT_JOB_PATH, undefined, options);
}

export async function exportRawTestData(
  query: {
    dateFrom: string;
    testTypes?: TestType[];
    dateTo?: string;
  },
  options?: ExportRequestOptions,
): Promise<TestExportResponse | null> {
  return executeExportRequest(RAW_EXPORT_JOB_PATH, query, options);
}

export async function reportVirtualAssistantVideoIssue(
  report: VirtualAssistantVideoIssueReportRequest,
): Promise<void> {
  return new Promise((resolve, reject) => {
    postMethod(
      VIRTUAL_ASSISTANT_VIDEO_ISSUE_REPORT_PATH,
      {},
      report,
      () => resolve(),
      (error) => reject(error),
    );
  });
}

export function getUser(
  queryMap: {},
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  getMethod(USER_PATH, queryMap, callback, errorCallback, unAuth);
}

export async function fetchEligibleNotification(
  query: { pathname: string; headsetVersion: string },
  signal?: AbortSignal,
): Promise<EligibleNotification | null> {
  const response = await getAxiosInstance().get(NOTIFICATIONS_ELIGIBLE_PATH, {
    params: query,
    headers: getHeaders(),
    signal,
    validateStatus: (status) => status === 200 || status === 204,
  });
  return response.status === 204 ? null : (response.data as EligibleNotification);
}

export async function recordNotificationEvent(
  notificationId: string,
  event: NotificationEventRequest,
): Promise<void> {
  const idempotentEvent = {
    ...event,
    eventId: event.eventId ?? uuidv4(),
  };
  await getAxiosInstance().post(
    `${NOTIFICATIONS_PATH}/${encodeURIComponent(notificationId)}/events`,
    idempotentEvent,
    { headers: getHeaders() },
  );
}

export async function getAdminConfigurations(): Promise<AdminConfigurationsResponse> {
  const response = await getAxiosInstance().get(ADMIN_CONFIGURATIONS_PATH, {
    headers: getHeaders(),
  });
  return response.data as AdminConfigurationsResponse;
}

export async function updateAdminConfigurations(
  payload: AdminConfigurations,
): Promise<AdminConfigurationsResponse> {
  const response = await getAxiosInstance().put(ADMIN_CONFIGURATIONS_PATH, payload, {
    headers: getHeaders(),
  });
  return response.data as AdminConfigurationsResponse;
}

export async function getAdminNotifications(): Promise<AdminNotification[]> {
  const response = await getAxiosInstance().get(NOTIFICATIONS_ADMIN_PATH, {
    headers: getHeaders(),
  });
  return response.data as AdminNotification[];
}

export async function createAdminNotification(
  payload: NotificationPayload,
): Promise<AdminNotification> {
  const response = await getAxiosInstance().post(NOTIFICATIONS_ADMIN_PATH, payload, {
    headers: getHeaders(),
  });
  return response.data as AdminNotification;
}

export async function updateAdminNotification(
  notificationId: string,
  payload: Partial<NotificationPayload>,
): Promise<AdminNotification> {
  const response = await getAxiosInstance().patch(
    `${NOTIFICATIONS_ADMIN_PATH}/${encodeURIComponent(notificationId)}`,
    payload,
    { headers: getHeaders() },
  );
  return response.data as AdminNotification;
}

export async function deleteAdminNotification(notificationId: string): Promise<void> {
  await getAxiosInstance().delete(
    `${NOTIFICATIONS_ADMIN_PATH}/${encodeURIComponent(notificationId)}`,
    { headers: getHeaders() },
  );
}

export async function createAdminNotificationTarget(
  notificationId: string,
  payload: NotificationTargetPayload,
): Promise<AdminNotification> {
  const response = await getAxiosInstance().post(
    `${NOTIFICATIONS_ADMIN_PATH}/${encodeURIComponent(notificationId)}/targets`,
    payload,
    { headers: getHeaders() },
  );
  return response.data as AdminNotification;
}

export async function deleteAdminNotificationTarget(
  notificationId: string,
  targetId: string,
): Promise<AdminNotification> {
  const response = await getAxiosInstance().delete(
    `${NOTIFICATIONS_ADMIN_PATH}/${encodeURIComponent(notificationId)}/targets/${encodeURIComponent(targetId)}`,
    { headers: getHeaders() },
  );
  return response.data as AdminNotification;
}

export async function getChatbaseIdentity(): Promise<{
  token: string;
  publicAttributes?: Record<string, string>;
}> {
  return new Promise((resolve, reject) => {
    getMethod(
      CHATBASE_IDENTITY_PATH,
      {},
      (response) => resolve(response.data),
      (error) => reject(error),
    );
  });
}

export function exportAnalyticsPage(
  data: { distId: string },
  callback?: (val: any) => void,
  errorCallback?: (val: any) => void,
  unAuth?: (val: any) => void,
) {
  return getMethod(ANALYTICS_EXPORT_PATH, { distId: data.distId }, callback, errorCallback, unAuth);
}

export function fetchDistributorTestCounts(
  distId: string,
  startDate?: string,
  endDate?: string,
  callback?: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  return new Promise((resolve, reject) => {
    getMethod(
      ANALYTICS_TEST_COUNT_BY_DISTRIBUTOR_PATH,
      { distId, ...(startDate && endDate ? { startDate, endDate } : {}) },
      (response) => {
        if (typeof callback === "function") {
          callback(response);
        }
        resolve(response.data);
      },
      (error) => {
        if (typeof errorCallback === "function") {
          errorCallback(error);
        }
        reject(error);
      },
      unAuth,
    );
  });
}

export function fetchMultiAccountDevices(
  distId: string,
  callback?: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  return new Promise((resolve, reject) => {
    getMethod(
      ANALYTICS_MULTI_ACCOUNT_DEVICES_PATH,
      { distId },
      (response) => {
        if (typeof callback === "function") {
          callback(response);
        }
        resolve(response.data);
      },
      (error) => {
        if (typeof errorCallback === "function") {
          errorCallback(error);
        }
        reject(error);
      },
      unAuth,
    );
  });
}

export function fetchDistributorComparison(
  startDate?: string,
  endDate?: string,
  callback?: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  return new Promise((resolve, reject) => {
    getMethod(
      ANALYTICS_DISTRIBUTOR_COMPARISON_PATH,
      startDate && endDate ? { startDate, endDate } : {},
      (response) => {
        if (typeof callback === "function") {
          callback(response);
        }
        resolve(response.data);
      },
      (error) => {
        if (typeof errorCallback === "function") {
          errorCallback(error);
        }
        reject(error);
      },
      unAuth,
    );
  });
}

export function fetchDemoTestTotals(
  distId: string,
  callback?: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  return new Promise((resolve, reject) => {
    getMethod(
      ANALYTICS_DEMO_TEST_TOTALS_PATH,
      { distId },
      (response) => {
        if (typeof callback === "function") {
          callback(response);
        }
        resolve(response.data);
      },
      (error) => {
        if (typeof errorCallback === "function") {
          errorCallback(error);
        }
        reject(error);
      },
      unAuth,
    );
  });
}

export function fetchDistributorSales(
  distId: string,
  startDate?: string,
  endDate?: string,
  callback?: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  return new Promise((resolve, reject) => {
    getMethod(
      ANALYTICS_DISTRIBUTOR_SALES_PATH,
      { distId, ...(startDate && endDate ? { startDate, endDate } : {}) },
      (response) => {
        if (typeof callback === "function") {
          callback(response);
        }
        resolve(response.data);
      },
      (error) => {
        if (typeof errorCallback === "function") {
          errorCallback(error);
        }
        reject(error);
      },
      unAuth,
    );
  });
}

export function fetchOrgTestCounts(
  orgId: string,
  callback?: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  return new Promise((resolve, reject) => {
    getMethod(
      ANALYTICS_TEST_COUNT_PATH,
      { orgId },
      (response) => {
        if (typeof callback === "function") {
          callback(response);
        }
        resolve(response.data);
      },
      (error) => {
        if (typeof errorCallback === "function") {
          errorCallback(error);
        }
        reject(error);
      },
      unAuth,
    );
  });
}

export function fetchDeviceTestCounts(
  deviceId: string,
  orgId: string,
  callback?: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  return new Promise((resolve, reject) => {
    getMethod(
      ANALYTICS_TEST_COUNT_BY_DEVICE_PATH,
      { deviceId, orgId },
      (response) => {
        if (typeof callback === "function") {
          callback(response);
        }
        resolve(response.data);
      },
      (error) => {
        if (typeof errorCallback === "function") {
          errorCallback(error);
        }
        reject(error);
      },
      unAuth,
    );
  });
}

export function fetchCategoryDistribution(
  distId: string,
  startDate?: string,
  endDate?: string,
  callback?: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  return new Promise((resolve, reject) => {
    getMethod(
      ANALYTICS_CATEGORY_DISTRIBUTION_BY_DISTRIBUTOR_PATH,
      { distId, ...(startDate && endDate ? { startDate, endDate } : {}) },
      (response) => {
        if (typeof callback === "function") {
          callback(response);
        }
        resolve(response.data);
      },
      (error) => {
        if (typeof errorCallback === "function") {
          errorCallback(error);
        }
        reject(error);
      },
      unAuth,
    );
  });
}

export function fetchOrgBreakdown(
  orgId: string,
  startDate?: string,
  endDate?: string,
  callback?: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  return new Promise((resolve, reject) => {
    getMethod(
      ANALYTICS_ORG_BREAKDOWN_PATH,
      { orgId, ...(startDate && endDate ? { startDate, endDate } : {}) },
      (response) => {
        if (typeof callback === "function") {
          callback(response);
        }
        resolve(response.data);
      },
      (error) => {
        if (typeof errorCallback === "function") {
          errorCallback(error);
        }
        reject(error);
      },
      unAuth,
    );
  });
}

export function fetchAllDistributorIds(
  callback?: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  return new Promise((resolve, reject) => {
    getMethod(
      DISTRIBUTOR_IDS_WITH_COUNTRY_PATH,
      {},
      (response) => {
        if (typeof callback === "function") {
          callback(response);
        }
        resolve(response.data);
      },
      (error) => {
        if (typeof errorCallback === "function") {
          errorCallback(error);
        }
        reject(error);
      },
      unAuth,
    );
  });
}

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(("" + reader.result).split("base64,")[1]);
    reader.onerror = (error) => reject(error);
  });

export function getOrders(
  queryMap: { status?: string; page?: number; orderId?: string },
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  getMethod(MANAGEMENT_ORDERS_PATH, queryMap, callback, errorCallback);
}

export function setOrderIsPaid(
  _id: string,
  isPaid: boolean,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  putMethod(
    `${MANAGEMENT_ORDERS_PATH}`,
    { id: _id, isPaid },
    null,
    (a, response) => {
      if (typeof callback === "function") callback(response);
    },
    errorCallback,
  );
}

export function performOrderAction(
  _id: string,
  action: string,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  // For cancel/reject the backend exposes PUT /management/orders/cancel with body { id, status }
  if (action === "cancelled" || action === "rejected") {
    putMethod(
      `${MANAGEMENT_ORDERS_PATH}/cancel`,
      {},
      { status: action, id: _id },
      (a, response) => {
        if (typeof callback === "function") callback(response);
      },
      errorCallback,
    );
    return;
  }

  // For approve action call the approve endpoint: PUT /management/orders/approve with body { id }
  if (action === "approved") {
    putMethod(
      `${MANAGEMENT_ORDERS_PATH}/approve`,
      {},
      { id: _id },
      (a, response) => {
        if (typeof callback === "function") callback(response);
      },
      errorCallback,
    );
  }
}

export function updateOrder(
  _id: string,
  data: any,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  putMethod(
    MANAGEMENT_ORDERS_PATH,
    { id: _id },
    data,
    (a, response) => {
      // putMethod returns callback(data["uuid"], response) - normalize to response
      if (typeof callback === "function") callback(response);
    },
    errorCallback,
  );
}

export function createOrder(
  data: any,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  postMethod(MANAGEMENT_ORDERS_PATH, {}, data, callback, errorCallback);
}

export function getLicenses(
  queryMap: {
    distId?: string;
    orderId?: string;
    licenseState?: string;
    licenseType?: string;
    page?: number;
  },
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  getMethod(MANAGEMENT_LICENCES_PATH, queryMap, callback, errorCallback);
}

export function assignLicenses(
  queryMap: { orderId?: string; replaceAssignment?: boolean },
  body: AssignLicensesToOrganizationsDto,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  postMethod(`${MANAGEMENT_LICENCES_PATH}/assign`, queryMap, body, callback, errorCallback);
}

export function getAssignLicenseRequests(
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  getMethod(MANAGEMENT_ASSIGN_REQUESTS_PATH, {}, callback, errorCallback);
}

export function approveAssignLicenseRequest(
  body: { requestId: string; orgId: string; password: string },
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  putMethod(MANAGEMENT_ASSIGN_REQUESTS_PATH, {}, body, callback, errorCallback);
}

export function getInvoices(
  queryMap: { distId?: string; invoiceNo?: string; date?: string },
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  getMethod(MANAGEMENT_INVOICES_PATH, queryMap, callback, errorCallback);
}

export function getInvoicesBySku(
  sku: string,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  getMethod(`${MANAGEMENT_INVOICES_PATH}/by-sku/${sku}`, {}, callback, errorCallback);
}

function downloadBlob(
  path: string,
  fallbackFilename: string,
  callback: (blob: Blob, filename: string) => void,
  errorCallback?: (val: any) => void,
  config: Record<string, any> = {},
) {
  getAxiosInstance()
    .get(path, { headers: getHeaders(), responseType: "blob", ...config })
    .then((response) => {
      const disposition = response.headers["content-disposition"] ?? "";
      const match = disposition.match(/filename[^;=\n]*=(['"]?)([^'";\n]+)\1/);
      callback(response.data, match?.[2]?.trim() || fallbackFilename);
    })
    .catch((error) => {
      logError(error);
      if (typeof errorCallback === "function") errorCallback(error);
    });
}

export function exportInvoices(
  queryMap: { distId?: string; invoiceNo?: string; date?: string },
  callback: (blob: Blob, filename: string) => void,
  errorCallback?: (val: any) => void,
) {
  downloadBlob(
    `${MANAGEMENT_INVOICES_PATH}/export` + convertToQueryString(queryMap),
    "invoices-export.csv",
    callback,
    errorCallback,
  );
}

export function downloadDeviceDayLog(
  pid: string,
  date: string,
  callback: (blob: Blob, filename: string) => void,
  errorCallback?: (val: any) => void,
) {
  downloadBlob(
    `${WS_PATH}/day-log` + convertToQueryString({ pid, date }),
    `${pid}-${date}.log`,
    callback,
    errorCallback,
    // 0 disables the instance default: an absolute deadline would abort a large
    // transfer still making progress. The backend's idle deadline catches stalls.
    { timeout: 0 },
  );
}

export function updateInvoicesLicensesGenerated(
  body: { ids: string[]; softLicensesGenerated: boolean; distId?: string },
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  patchMethod(`${MANAGEMENT_INVOICES_PATH}/licenses-generated`, {}, body, callback, errorCallback);
}

export function deleteInvoices(
  ids: string[],
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
  distId?: string,
) {
  getAxiosInstance()
    .delete(MANAGEMENT_INVOICES_PATH, {
      headers: getHeaders(),
      data: distId ? { ids, distId } : { ids },
    })
    .then(callback)
    .catch((error) => {
      logError(error);
      if (typeof errorCallback === "function") errorCallback(error);
    });
}

export function deleteLicenses(
  ids: string[],
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
  distId?: string,
) {
  getAxiosInstance()
    .delete(MANAGEMENT_LICENCES_PATH, {
      headers: getHeaders(),
      data: { ids, distId },
    })
    .then(callback)
    .catch((error) => {
      logError(error);
      if (typeof errorCallback === "function") errorCallback(error);
    });
}

export function uploadInvoicesCsv(
  file: File,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
  distId?: string,
) {
  const formData = new FormData();
  formData.append("file", file);
  if (distId) formData.append("distId", distId);

  postMethod(
    MANAGEMENT_IMPORT_INVOICES_CSV_PATH,
    {},
    formData,
    callback,
    errorCallback,
    undefined,
    undefined,
    { headers: getHeaders({ "Content-Type": "multipart/form-data" }) },
  );
}

export function uploadInvoicesJson(
  file: File,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  const formData = new FormData();
  formData.append("file", file);

  postMethod(
    MANAGEMENT_IMPORT_INVOICES_JSON_PATH,
    {},
    formData,
    callback,
    errorCallback,
    undefined,
    undefined,
    { headers: getHeaders({ "Content-Type": "multipart/form-data" }) },
  );
}

export function updateInvoiceEntry(
  invoiceId: string,
  sku: string,
  body: { distId?: string; sku?: string; quantity?: number },
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  patchMethod(
    `${MANAGEMENT_INVOICES_PATH}/${invoiceId}/entries/${sku}`,
    {},
    body,
    callback,
    errorCallback,
  );
}

export function getInvoiceSkuTypes(
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  getMethod(MANAGEMENT_INVOICE_SKU_TYPES_PATH, {}, callback, errorCallback);
}

export function createInvoiceSkuType(
  body: { sku: string; description: string; licenseType?: string; isActive?: boolean },
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  postMethod(MANAGEMENT_INVOICE_SKU_TYPES_PATH, {}, body, callback, errorCallback);
}

export function updateInvoiceSkuType(
  sku: string,
  body: { sku?: string; description?: string; licenseType?: string; isActive?: boolean },
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  patchMethod(`${MANAGEMENT_INVOICE_SKU_TYPES_PATH}/${sku}`, {}, body, callback, errorCallback);
}

export function deleteInvoiceSkuType(
  sku: string,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  deleteMethod(`${MANAGEMENT_INVOICE_SKU_TYPES_PATH}/${sku}`, {}, callback, errorCallback);
}

export function getSoftGenerateCount(
  body: { distId: string; dryRun: boolean },
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  postMethod(`${MANAGEMENT_LICENCES_PATH}/soft-generate-count`, {}, body, callback, errorCallback);
}

export function softGenerateLicenses(
  body: { distId: string; dryRun?: boolean },
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  postMethod(`${MANAGEMENT_LICENCES_PATH}/soft-generate`, {}, body, callback, errorCallback);
}

export function unassignLicenses(
  data: { licenseUuids: string[]; orgId: string },
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
) {
  putMethod(`${MANAGEMENT_LICENCES_PATH}/unassign`, {}, data, callback, errorCallback);
}

export function createTestSuite(
  data: {
    uuid: string;
    name: string;
    tests: any[];
    neededVersion?: string;
    overview?: TestSuiteOverview;
  },
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
  unAuth?: () => void,
) {
  if (!isLoggedIn(unAuth)) return;
  getAxiosInstance()
    .post(TEST_SUITE_PATH, data, {
      headers: {
        Authorization: `Bearer ${SecureTokenManager.getAccessToken()}`,
      },
    })
    .then(
      (response) => {
        callback(response.data);
      },
      (error) => {
        if (errorCallback) {
          errorCallback(error);
        }
      },
    );
}

export function updateTestSuite(
  uuid: string,
  data: {
    name: string;
    tests: any[];
    neededVersion?: string;
    overview?: TestSuiteOverview;
  },
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
  unAuth?: () => void,
) {
  if (!isLoggedIn(unAuth)) return;
  getAxiosInstance()
    .put(`${TEST_SUITE_PATH}/${uuid}`, data, {
      headers: {
        Authorization: `Bearer ${SecureTokenManager.getAccessToken()}`,
      },
    })
    .then(
      (response) => {
        callback(response.data);
      },
      (error) => {
        if (errorCallback) {
          errorCallback(error);
        }
      },
    );
}

export function getTestSuites(
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
  unAuth?: () => void,
) {
  if (!isLoggedIn(unAuth)) return;
  getAxiosInstance()
    .get(TEST_SUITE_PATH, {
      headers: {
        Authorization: `Bearer ${SecureTokenManager.getAccessToken()}`,
      },
    })
    .then(
      (response) => {
        callback(response.data);
      },
      (error) => {
        if (errorCallback) {
          errorCallback(error);
        }
      },
    );
}

export function getTestSuite(
  uuid: string,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
  unAuth?: () => void,
) {
  // No token = print route (render-token fetch), so proceed. A present-but-
  // invalid token means isLoggedIn already fired logout + unAuth; bail rather
  // than send a doomed request that also triggers errorCallback.
  const hadToken = !!SecureTokenManager.getAccessToken();
  if (!isLoggedIn(unAuth) && hadToken) return;
  getAxiosInstance()
    .get(`${TEST_SUITE_PATH}/${uuid}`, {
      headers: {
        Authorization: `Bearer ${SecureTokenManager.getAccessToken()}`,
      },
    })
    .then(
      (response) => {
        callback(response.data);
      },
      (error) => {
        if (errorCallback) {
          errorCallback(error);
        }
      },
    );
}

export function deleteTestSuite(
  uuid: string,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
  unAuth?: () => void,
) {
  if (!isLoggedIn(unAuth)) return;
  getAxiosInstance()
    .delete(`${TEST_SUITE_PATH}/${uuid}`, {
      headers: {
        Authorization: `Bearer ${SecureTokenManager.getAccessToken()}`,
      },
    })
    .then(
      (response) => {
        callback(response.data);
      },
      (error) => {
        if (errorCallback) {
          errorCallback(error);
        }
      },
    );
}

export function getTestSuiteSessions(
  queryMap: Record<string, unknown>,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
  unAuth?: (val: any) => void,
) {
  getMethod(TEST_SUITE_SESSION_PATH, queryMap, callback, errorCallback, unAuth);
}

export function getTestSuiteSession(
  sessionId: string,
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
  unAuth?: (val: any) => void,
) {
  // No token = print route (render-token fetch), so proceed. A present-but-
  // invalid token means isLoggedIn already fired logout + unAuth; bail rather
  // than send a doomed request that also triggers errorCallback.
  const hadToken = !!SecureTokenManager.getAccessToken();
  if (!isLoggedIn(unAuth) && hadToken) return;
  getAxiosInstance()
    .get(`${TEST_SUITE_SESSION_PATH}/${sessionId}`, {
      headers: getHeaders(),
    })
    .then(
      (response) => {
        callback(response);
      },
      (error) => {
        if (errorCallback) {
          errorCallback(error);
        }
      },
    );
}

export function createTestSuiteSession(
  data: {
    sessionId: string;
    testSuiteId: string;
    testSuiteName: string;
    patientId?: string;
    suiteStartedAt?: number;
  },
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
  unAuth?: () => void,
) {
  if (!isLoggedIn(unAuth)) return;
  getAxiosInstance()
    .post(TEST_SUITE_SESSION_PATH, data, {
      headers: {
        Authorization: `Bearer ${SecureTokenManager.getAccessToken()}`,
      },
    })
    .then(
      (response) => {
        callback(response.data);
      },
      (error) => {
        if (errorCallback) {
          errorCallback(error);
        }
      },
    );
}

export function updateTestSuiteSession(
  sessionId: string,
  data: { suiteEndedAt: number; status?: "completed" | "terminated" | "in_progress" },
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
  unAuth?: () => void,
) {
  if (!isLoggedIn(unAuth)) {
    if (typeof errorCallback === "function") errorCallback(new Error("Unauthorized"));
    return;
  }
  getAxiosInstance()
    .patch(`${TEST_SUITE_SESSION_PATH}/${sessionId}`, data, {
      headers: {
        Authorization: `Bearer ${SecureTokenManager.getAccessToken()}`,
      },
    })
    .then(
      (response) => {
        callback(response.data);
      },
      (error) => {
        if (errorCallback) {
          errorCallback(error);
        }
      },
    );
}

export function mergeTestSuiteSessions(
  data: { sessionIds: string[]; patientId: string },
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
  unAuth?: (val: any) => void,
) {
  if (!isLoggedIn(unAuth)) {
    if (typeof errorCallback === "function") errorCallback(new Error("Unauthorized"));
    return;
  }
  getAxiosInstance()
    .post(`${TEST_SUITE_SESSION_PATH}/merge`, data, {
      headers: {
        Authorization: `Bearer ${SecureTokenManager.getAccessToken()}`,
      },
    })
    .then(
      (response) => {
        callback(response.data);
      },
      (error) => {
        if (errorCallback) {
          errorCallback(error);
        }
      },
    );
}

export function addTestSuiteSessionResult(
  sessionId: string,
  data: {
    testSuiteTestId: string;
    completedTestResultId: string;
    testName: string;
    testType: string;
  },
  callback: (val: any) => void,
  errorCallback?: (val: any) => void,
  unAuth?: (val: any) => void,
) {
  if (!isLoggedIn(unAuth)) {
    if (typeof errorCallback === "function") errorCallback(new Error("Unauthorized"));
    return;
  }
  getAxiosInstance()
    .patch(`${TEST_SUITE_SESSION_PATH}/${sessionId}/results`, data, {
      headers: {
        Authorization: `Bearer ${SecureTokenManager.getAccessToken()}`,
      },
    })
    .then(
      (response) => {
        callback(response.data);
      },
      (error) => {
        if (errorCallback) {
          errorCallback(error);
        }
      },
    );
}
/* Blog API Methods */

export function getBlogPosts(page: number = 1, pageSize: number = 10) {
  return new Promise((resolve, reject) => {
    getMethod(
      BLOG_PATH,
      { page, pageSize },
      (response) => resolve(response.data),
      (error) => reject(error),
    );
  });
}

export function getBlogPostBySlug(slug: string) {
  return new Promise((resolve, reject) => {
    getMethod(
      `${BLOG_PATH}/${slug}`,
      {},
      (response) => resolve(response.data),
      (error) => reject(error),
    );
  });
}

export function uploadBlogImage(file: File, slug?: string) {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("file", file);
    if (slug) {
      formData.append("slug", slug);
    }

    getAxiosInstance()
      .post(BLOG_PATH + "/image", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          ...getHeaders(),
        },
      })
      .then((response) => resolve(response.data.url))
      .catch((error) => {
        console.error(error);
        logError(error);
        reject(error);
      });
  });
}

export function createBlogPost(payload: any) {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("payload", JSON.stringify(payload));

    getAxiosInstance()
      .post(BLOG_PATH, formData, {
        headers: {
          "Content-Type": "application/json",
          ...getHeaders(),
        },
      })
      .then((response) => resolve(response.data))
      .catch((error) => {
        console.error(error);
        logError(error);
        reject(error);
      });
  });
}

export function patchUser(
  data: { name?: string; email?: string },
  callback: (val) => void,
  errorCallback?: (val) => void,
) {
  patchMethod(USER_PATH, {}, data, callback, errorCallback);
}

export function getTranslationsPaginated(
  language: string,
  queryMap: {},
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
  signal?: AbortSignal,
) {
  getMethod(
    `${TRANSLATIONS_PAGINATED_PATH}/${language}`,
    queryMap,
    callback,
    errorCallback,
    unAuth,
    undefined,
    signal,
  );
}

export function updateTranslation(
  params: { namespace: string; key: string; language: string },
  data: { value?: string; isApproved?: boolean },
  callback: (val) => void,
  errorCallback?: (val) => void,
  unAuth?: (val) => void,
) {
  const url = `${TRANSLATIONS_PATH}/${encodeURIComponent(params.namespace)}/${encodeURIComponent(
    params.key,
  )}/${encodeURIComponent(params.language)}`;

  putMethod(url, {}, data, (_, response) => callback(response), errorCallback, unAuth);
}

function parentOfferPath(slug: string): string {
  return `${MANAGEMENT_PARENT_OFFERS_PATH}/${encodeURIComponent(slug)}`;
}

export async function getParentOffers(): Promise<AdminSchoolOffersResponse> {
  const response = await getAxiosInstance().get(MANAGEMENT_PARENT_OFFERS_PATH, {
    headers: getHeaders(),
  });
  return response.data as AdminSchoolOffersResponse;
}

export async function getParentOffer(slug: string): Promise<AdminSchoolOffer> {
  const response = await getAxiosInstance().get(parentOfferPath(slug), { headers: getHeaders() });
  return response.data as AdminSchoolOffer;
}

export async function createParentOffer(input: ParentOfferInput): Promise<AdminSchoolOffer> {
  const response = await getAxiosInstance().post(MANAGEMENT_PARENT_OFFERS_PATH, input, {
    headers: getHeaders(),
  });
  return response.data as AdminSchoolOffer;
}

export async function updateParentOffer(
  slug: string,
  input: ParentOfferInput,
): Promise<AdminSchoolOffer> {
  const response = await getAxiosInstance().put(parentOfferPath(slug), input, {
    headers: getHeaders(),
  });
  return response.data as AdminSchoolOffer;
}

export async function uploadParentOfferLogo(logo: File): Promise<ParentOfferLogoUpload> {
  const formData = new FormData();
  formData.append("logo", logo);
  const response = await getAxiosInstance().post(
    `${MANAGEMENT_PARENT_OFFERS_PATH}/logo`,
    formData,
    {
      headers: getHeaders(),
    },
  );
  return response.data as ParentOfferLogoUpload;
}

export async function searchParentOfferOrgs(
  search: string,
  signal?: AbortSignal,
): Promise<ParentOfferOrgSearchResponse> {
  const response = await getAxiosInstance().get(`${MANAGEMENT_PARENT_OFFERS_PATH}/orgs`, {
    headers: getHeaders(),
    params: { search },
    signal,
  });
  return response.data as ParentOfferOrgSearchResponse;
}

export async function checkParentOfferCurrency(
  currency: string,
  signal?: AbortSignal,
): Promise<ParentOfferCurrencyCheck> {
  const response = await getAxiosInstance().get(`${MANAGEMENT_PARENT_OFFERS_PATH}/currency-check`, {
    headers: getHeaders(),
    params: { currency },
    signal,
  });
  return response.data as ParentOfferCurrencyCheck;
}

export async function getParentOfferRegistrations(
  query: RegistrationsQuery,
  signal?: AbortSignal,
): Promise<RegistrationsResponse> {
  const response = await getAxiosInstance().get(`${MANAGEMENT_PARENT_OFFERS_PATH}/registrations`, {
    headers: getHeaders(),
    params: query,
    signal,
  });
  return response.data as RegistrationsResponse;
}
